export const precinctSelector = (state) => state.precinct;